import { CatIcon } from './CatIcon';

/**
 * author: Austin Andrews
 * id 5D3A753E-1FA9-42F4-8A71-E686A36D1CB6
 * name cat
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cat.svg
 * tags
 * - Animal 
 * - Holiday 
 */
export const EmojiCatIcon = CatIcon;
export default EmojiCatIcon